import type { ItemShouldAnnounceChangeFunction } from '@splunk/dashboard-types';
import type { PresetHOC } from '../types/PresetHOC';

/**
 * Add a property to the preset item that determines when the changes in component warrant an announcement
 */
export const withCustomShouldAnnounceChange: PresetHOC<
    { shouldAnnounceChange?: ItemShouldAnnounceChangeFunction },
    { shouldAnnounceChange?: ItemShouldAnnounceChangeFunction }
> = (Item, { shouldAnnounceChange } = {}) => {
    Item.shouldAnnounceChange = shouldAnnounceChange;

    return Item;
};
